'use client';

import { useSession } from "next-auth/react";
import { Box, Stack } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import AvatarMenu from "@/app/features/sites/header/ui/desktop/AvatarMenu";

const HOME_HREF = "/";

export default function Centerpiece() {

    return (
        <Box className="flex flex-grow-0 flex-shrink basis-full mx-4" role="none">

            <Link href={HOME_HREF} tabIndex={-1} aria-hidden={true} prefetch>
                <Stack
                    direction="row"
                    spacing={1.5}
                    justifyContent="center"
                    alignItems="center"
                    alignContent="center"
                    maxHeight="64px"
                    role="none"
                >
                    <AvatarOrLogo />
                    <TextLogo />
                </Stack>
            </Link>
        </Box>
    )
}

function AvatarOrLogo() {

    const { data: session } = useSession();

    return session && session.user
        ? (
            <Box sx={{ width: 56, height: 56, flexShrink: 0 }}>
                <AvatarMenu user={session.user}/>
            </Box>
        ) : (
            <Box sx={{ height: '100%' }}>
                <Image
                    src='/assets/logo/logo_small_icon_only.webp'
                    alt='Logo museum erding'
                    style={{
                        padding: '8px',
                        height: '100%',
                        width: 'auto',
                        aspectRatio: '1/1'
                    }}
                    width={60}
                    height={60}
                    priority
                />
            </Box>
        )

}

function TextLogo() {
    return (
        <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            role="none"
            sx={{
                height: '100%',
                maxHeight: 'inherit',
            }}
        >
            <Image
                src='/assets/logo/logo_small_text_only.webp'
                alt='Logo museum erding'
                style={{
                    // padding: '8px',
                    height: '100%',
                    maxHeight: 'inherit',
                    width: 'auto',
                }}
                width={600}
                height={600}
                priority
            />
        </Box>
    )
}
